import { v4 as uuid } from 'uuid';
import { ActiveMessagesConstants } from './ActiveMessagesConstants';
import { CampaignType } from './models/CampaignType';
import { isNullOrWhiteSpace } from 'data/string';
import { ActiveMessagesFeatures } from './ActiveMessagesFeatures';
export class ActiveMessageService {
    static $inject = ['MessagingHubService', 'CallerConfigurationService', 'ApplicationService2', 'AccountService2', 'FileSaver'];
    constructor(MessagingHubService, CallerConfigurationService, ApplicationService2, AccountService2, FileSaver) {
        this.MessagingHubService = MessagingHubService;
        this.CallerConfigurationService = CallerConfigurationService;
        this.ApplicationService2 = ApplicationService2;
        this.AccountService2 = AccountService2;
        this.FileSaver = FileSaver;
        this.cluster = '';
        this.changesDisplayActiveCampaignData = ActiveMessagesFeatures.changesDisplayActiveCampaignDataDefaultValue;
        this.$onInit();
    }
    $onInit() {
        this.resource = {};
        this.updateFutureToggle();
    }
    async listStates(childrenShortName, isToUseNewFlowAndIdListing) {
        if (!isToUseNewFlowAndIdListing) {
            return this.getChildrenApplication(childrenShortName);
        }
        const states = await this.listBotState(childrenShortName);
        if (!states) {
            return;
        }
        return {
            items: states.items.map((item, i) => {
                return {
                    shortName: item.id,
                    longName: item.name,
                };
            }),
            Template: 'builder',
        };
    }
    async getChildrenApplication(childrenShortName) {
        const childrenFullName = `${childrenShortName}${ActiveMessagesConstants.MSGING_SUFFIX}`;
        let clusterUri = '';
        let configuration = { Cluster: undefined };
        try {
            configuration = await this.CallerConfigurationService.getWithCaller(childrenFullName, ActiveMessagesConstants.ADMIN_IDENTITY, `${childrenFullName}/default`, this.MessagingHubService.getLocalNode());
        }
        catch (err) {
            configuration = { Cluster: undefined };
        }
        if (configuration.Cluster) {
            if (configuration.Cluster != ActiveMessagesConstants.CLUSTER_DEFAULT) {
                this.cluster = configuration.Cluster.toLowerCase();
                clusterUri = `${this.cluster}${ActiveMessagesConstants.DOT_CHARACTER}`;
            }
        }
        const command = {
            method: 'get',
            from: `${childrenFullName}/default`,
            pp: this.MessagingHubService.getLocalNode(),
            uri: `${ActiveMessagesConstants.COMMAND_PREFIX}${clusterUri}${ActiveMessagesConstants.COMMAND_SUFFIX}`,
        };
        return await this.MessagingHubService.sendCommand(command);
    }
    async listBotState(childrenShortName) {
        let uri = `${ActiveMessagesConstants.FLOW_STATES}`;
        if (!isNullOrWhiteSpace(childrenShortName)) {
            uri += `?shortName=${childrenShortName}`;
        }
        const command = {
            method: 'get',
            id: uuid(),
            to: ActiveMessagesConstants.BUILDER_POSTMASTER,
            uri: uri,
        };
        try {
            return await this.MessagingHubService.sendCommand(command);
        }
        catch (e) {
            const error = JSON.parse(e);
            if (error.reason.code !== 67) {
                console.error(e);
            }
        }
    }
    async getFlowId(childrenShortName) {
        let uri = `${ActiveMessagesConstants.FLOW_IDS}`;
        if (!isNullOrWhiteSpace(childrenShortName)) {
            uri += `?shortName=${childrenShortName}`;
        }
        const command = {
            method: 'get',
            id: uuid(),
            to: ActiveMessagesConstants.BUILDER_POSTMASTER,
            uri: uri,
        };
        return await this.MessagingHubService.sendCommand(command);
    }
    async dispatchCampaign(campaignId) {
        const command = {
            id: uuid(),
            to: ActiveMessagesConstants.ACTIVE_CAMPAIGN_POSTMASTER,
            method: 'set',
            uri: ActiveMessagesConstants.DISPATCH_URI,
            type: ActiveMessagesConstants.CAMPAIGN_COMMAND_CONTENT_TYPE,
            resource: {
                id: campaignId,
            },
        };
        return this.MessagingHubService.sendCommand(command);
    }
    async create(data) {
        this.resource = data;
        const campaignResource = this.prepareCampaignResource();
        const campaign = await this.createCampaign(campaignResource);
        this.campaignId = campaign.id;
        const audienceResource = this.getAudienceResources();
        const contentResource = this.getContentResources();
        if (this.resource.audience.campaignType !== CampaignType.Batch) {
            await this.setAudience(audienceResource);
        }
        await this.setContent(contentResource);
        return this.campaignId;
    }
    async setAudience(resource) {
        const command = {
            id: uuid(),
            to: ActiveMessagesConstants.ACTIVE_CAMPAIGN_POSTMASTER,
            method: 'set',
            uri: `${ActiveMessagesConstants.AUDIENCES_URI}/${this.campaignId}`,
            type: ActiveMessagesConstants.AUDIENCE_COMMAND_CONTENT_TYPE,
            resource: resource,
        };
        return await this.MessagingHubService.sendCommand(command);
    }
    async setContent(resource) {
        const command = {
            id: uuid(),
            to: ActiveMessagesConstants.ACTIVE_CAMPAIGN_POSTMASTER,
            method: 'set',
            uri: `${ActiveMessagesConstants.MESSAGES_URI}/${this.campaignId}`,
            type: ActiveMessagesConstants.MESSAGE_COMMAND_CONTENT_TYPE,
            resource: resource,
        };
        return await this.MessagingHubService.sendCommand(command);
    }
    async downloadCampaignReport(idCampaign, nameCampaign, finallyFunction) {
        let exception = undefined;
        try {
            const data = await this.getAudienceReport(idCampaign);
            const response = await fetch(data);
            const blob = await response.blob();
            const fileName = this.getFileName(nameCampaign);
            await this.FileSaver.saveAs(blob, fileName);
        }
        catch (err) {
            exception = err;
            console.error(err);
        }
        finally {
            if (finallyFunction) {
                finallyFunction(exception);
            }
        }
    }
    getFileName(nameCampaign) {
        return ActiveMessagesConstants.CAMPAIGN_REPORT_FILE_NAME_PREFIX + nameCampaign + ActiveMessagesConstants.CAMPAIGN_REPORT_FILE_EXTENSION;
    }
    getAudienceResources() {
        return {
            recipient: this.resource.audience.value[0].description,
            recipientType: ActiveMessagesConstants.PHONE_NUMBER,
            channelType: ActiveMessagesConstants.WHATSAPP,
            messageParams: this.resource.content.params.audienceParams,
        };
    }
    getContentResources() {
        return {
            messageTemplate: this.resource.content.params.template,
            messageTemplateLanguage: this.resource.content.params.language,
            messageParams: this.resource.content.params.messageParams,
            channelType: ActiveMessagesConstants.WHATSAPP,
        };
    }
    prepareCampaignResource() {
        return {
            name: this.resource.campaignName,
            campaignType: this.resource.audience.campaignType || CampaignType.Individual,
            flowId: this.resource.responseTargeting?.params.flowId,
            stateId: this.resource.responseTargeting?.params.stateId,
            fileUrl: this.resource.audience.fileUrl,
            masterState: this.getMasterState(),
            scheduled: this.resource.schedule,
            attendanceRedirect: this.resource.responseTargeting?.params.attendanceRedirect ?
                this.resource.responseTargeting?.params.attendanceRedirect.replace('@', '%40') + '@blip.ai' : undefined,
            notificationEmail: this.resource.notificationEmail,
            notificationEmailLanguage: this.resource.notificationEmailLanguage,
            campaignSender: this.resource.notificationEmail,
            sourceApplication: 'Portal',
        };
    }
    getMasterState() {
        return this.resource.responseTargeting?.params.template === ActiveMessagesConstants.MASTER ?
            this.resource.responseTargeting?.params.masterState : undefined;
    }
    async createCampaign(campaignResource) {
        const command = {
            id: uuid(),
            to: ActiveMessagesConstants.ACTIVE_CAMPAIGN_POSTMASTER,
            method: 'set',
            uri: ActiveMessagesConstants.CAMPAIGNS_URI,
            type: ActiveMessagesConstants.CAMPAIGN_COMMAND_CONTENT_TYPE,
            resource: campaignResource,
        };
        return await this.MessagingHubService.sendCommand(command);
    }
    async mergeScheduledCampaign(campaignResource) {
        const command = {
            id: uuid(),
            to: ActiveMessagesConstants.ACTIVE_CAMPAIGN_POSTMASTER,
            method: 'merge',
            uri: ActiveMessagesConstants.CAMPAIGN_SCHEDULE_URI.replace('{campaignId}', campaignResource.id),
            type: ActiveMessagesConstants.CAMPAIGN_COMMAND_CONTENT_TYPE,
            resource: campaignResource,
        };
        return await this.MessagingHubService.sendCommand(command);
    }
    async setValidateAudienceFile(fileUrl) {
        const command = {
            id: uuid(),
            to: ActiveMessagesConstants.ACTIVE_CAMPAIGN_POSTMASTER,
            method: 'set',
            uri: ActiveMessagesConstants.VALIDATE_AUDIENCE_FILE_URI,
            type: ActiveMessagesConstants.VALIDATE_AUDIENCE_FILE_CONTENT_TYPE,
            resource: {
                url: fileUrl,
            },
        };
        return await this.MessagingHubService.sendCommand(command);
    }
    async getCampaigns() {
        const command = {
            id: uuid(),
            to: ActiveMessagesConstants.ACTIVE_CAMPAIGN_POSTMASTER,
            method: 'get',
            uri: ActiveMessagesConstants.CAMPAIGNS_URI,
        };
        return await this.MessagingHubService.sendCommand(command);
    }
    async getCampaign(campaignId) {
        const command = {
            id: uuid(),
            to: ActiveMessagesConstants.ACTIVE_CAMPAIGN_POSTMASTER,
            method: 'get',
            uri: ActiveMessagesConstants.CAMPAIGNS_URI + '/' + campaignId,
        };
        return await this.MessagingHubService.sendCommand(command);
    }
    async getAudienceSummary(skip, take, campaignName, isScheduledOnly) {
        let uri = `${ActiveMessagesConstants.AUDIENCES_SUMARY_URI}?$skip=${skip}&$take=${take}&scheduled=${isScheduledOnly}`;
        if (!isNullOrWhiteSpace(campaignName)) {
            uri += `&campaignName=${encodeURIComponent(campaignName)}`;
        }
        const command = {
            id: uuid(),
            to: ActiveMessagesConstants.ACTIVE_CAMPAIGN_POSTMASTER,
            method: 'get',
            uri: uri,
        };
        return await this.MessagingHubService.sendCommand(command);
    }
    async updateFutureToggle() {
        this.changesDisplayActiveCampaignData = await ActiveMessagesFeatures.isChangesDisplayActiveCampaignData();
    }
    async getAudienceReport(campaignId) {
        const me = await this.AccountService2.me();
        const command = {
            id: uuid(),
            to: ActiveMessagesConstants.ACTIVE_CAMPAIGN_POSTMASTER,
            method: 'get',
            uri: this.changesDisplayActiveCampaignData ?
                ActiveMessagesConstants.AUDIENCE_REPORT_URI.replace('{campaignId}', campaignId).replace('{language}', me.culture) :
                `${ActiveMessagesConstants.AUDIENCE_REPORT_URI_OLD}${campaignId}`,
        };
        const reportUrl = await this.MessagingHubService.sendCommand(command);
        if (!reportUrl) {
            throw new Error('Command returned empty value for audience report url');
        }
        return reportUrl;
    }
    async createAudience(audienceData) {
        const audienceResponse = ['phoneNumber\n'];
        audienceData.forEach(audienceItem => {
            const identitySplited = audienceItem?.identity
                ? audienceItem.identity.split('@')
                : undefined;
            if (identitySplited[1] == 'wa.gw.msging.net') {
                audienceResponse.push(`${identitySplited[0]}\n`);
            }
        });
        const fileAudience = new Blob(audienceResponse);
        const fileAudienceUrl = await this.ApplicationService2.uploadBlob(fileAudience, false, 'text/csv');
        return fileAudienceUrl;
    }
    async deleteCampaign(campaignId) {
        const command = {
            id: uuid(),
            to: ActiveMessagesConstants.ACTIVE_CAMPAIGN_POSTMASTER,
            method: 'delete',
            uri: `${ActiveMessagesConstants.CAMPAIGNS_URI}/${campaignId}`,
        };
        return this.MessagingHubService.sendCommand(command);
    }
    async getMessages(campaignId, skip, take) {
        const command = {
            id: uuid(),
            to: ActiveMessagesConstants.ACTIVE_CAMPAIGN_POSTMASTER,
            method: 'get',
            uri: `${ActiveMessagesConstants.MESSAGES_URI}/${campaignId}`,
        };
        const parameters = [];
        if (skip !== undefined) {
            parameters.push(`skip=${skip}`);
        }
        if (take !== undefined) {
            parameters.push(`take=${take}`);
        }
        if (parameters.length > 0) {
            command.uri += '?' + parameters.join('&');
        }
        return this.MessagingHubService.sendCommand(command);
    }
    async getMessage(campaignId) {
        const command = {
            id: uuid(),
            to: ActiveMessagesConstants.ACTIVE_CAMPAIGN_POSTMASTER,
            method: 'get',
            uri: `${ActiveMessagesConstants.MESSAGES_URI}/${campaignId}`,
        };
        return await this.MessagingHubService.sendCommand(command);
    }
    async getDeskConfigurationAsync() {
        return await this.MessagingHubService.processCommand({
            method: 'get',
            uri: 'lime://postmaster@desk.msging.net/configuration',
        });
    }
    async getDeskConfigurationFromBotBuilderAsync(botBuilderApplication, application) {
        const oldApplication = this.MessagingHubService.getCurrentClient().application;
        await this.MessagingHubService.resetClient(botBuilderApplication);
        const deskConfig = await this.getDeskConfigurationAsync();
        await this.MessagingHubService.resetClient(oldApplication);
        return deskConfig;
    }
}
ActiveMessageService.$inject = ['MessagingHubService', 'CallerConfigurationService', 'ApplicationService2', 'AccountService2', 'FileSaver'];
